module.exports = __webpack_public_path__ + "img/Manningham.d9b9302f84dc6436b9fa2464d894a8f2.png";